export const GET_PLAN_PERFORMANCE_ABORTED = 'GET_PLAN_PERFORMANCE_ABORTED';
export const GET_PLAN_PERFORMANCE_REQUESTED = 'GET_PLAN_PERFORMANCE_REQUESTED';
export const GET_PLAN_PERFORMANCE_COMPLETED = 'GET_PLAN_PERFORMANCE_COMPLETED';
export const GET_PLAN_PERFORMANCE_FAILED = 'GET_PLAN_PERFORMANCE_FAILED';
export const SET_PLAN_PERFORMANCE_FILTER_REQUESTED =
  'SET_PLAN_PERFORMANCE_FILTER_REQUESTED';
export const SET_PLAN_PERFORMANCE_FILTER_COMPLETED =
  'SET_PLAN_PERFORMANCE_FILTER_COMPLETED';
export const SET_PLAN_PERFORMANCE_FILTER_FAILED =
  'SET_PLAN_PERFORMANCE_FILTER_FAILED';

export const RESET_PLAN_PERFORMANCE_REQUESTED =
  'RESET_PLAN_PERFORMANCE_REQUESTED';
export const RESET_PLAN_PERFORMANCE_COMPLETED =
  'RESET_PLAN_PERFORMANCE_COMPLETED';
